// removed by extract-text-webpack-plugin
module.exports = {"root":"merchandising--root--YQH8MsxF organization-home--root--29mpR9MJ","tools":"merchandising--tools--2gKEXZoZ","filters":"merchandising--filters--1Kgzw2xV","filters-toggle":"merchandising--filters-toggle--2QJEnAgc","filtersToggle":"merchandising--filters-toggle--2QJEnAgc","filters-container":"merchandising--filters-container--3UJYLPrG","filtersContainer":"merchandising--filters-container--3UJYLPrG","hidden":"merchandising--hidden--1l2Qnq-Z","toggle":"merchandising--toggle--3fixAHmU"};


//////////////////
// WEBPACK FOOTER
// ./views/merchandising/styles.css
// module id = ./views/merchandising/styles.css
// module chunks = 0